// When importing enum values from @melio/payments-recon-api-client-ts, webpack
// throws an error because it tries to import node-related dependencies into client.
// We want to use enums provided by the package instead of duplicating them in GraphQL layer,
// so this is a temporary workaround until we find a solution for those imports
export function reconEnumValue<ValueType extends string>(
  extractedValue: `${ValueType}`
): ValueType {
  return extractedValue as ValueType;
}
